import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useRouter } from '@wbk/config';
import { WebSection, Zone } from '@wbk/contentful/api';
import { ChevronIcon } from '@wbk/svg';
import { Button } from '@wbk/ui';
import ZoneCard from '@/components/events/ZoneCard';
import ScrollTitle from '@/components/ui/ScrollTitle';

export default function Zones({ section }: { section: WebSection }) {
  const { locale } = useRouter();
  const { t } = useTranslation('common');

  const items = section.contentCollection.items as Zone[];
  const linkItem = section?.webLinksCollection?.items?.[0];
  const isExternal = linkItem && linkItem.href?.startsWith('http');

  return (
    <div className='container-padding container'>
      <section className='container px-3 xl:px-0'>
        <div className='space-y-6 lg:block lg:space-y-12'>
          <div className='flex w-full items-end justify-between'>
            <ScrollTitle title={section.title} className='max-w-md' />

            {linkItem && (
              <div className='flex'>
                <Button className='border-primary gap-1 rounded-full border bg-transparent px-4 py-1 transition-all duration-200 hover:bg-white/10 md:px-8'>
                  <Link
                    to={linkItem?.href}
                    target={isExternal ? '_blank' : '_self'}
                    rel={isExternal ? 'noopener noreferrer' : undefined}
                  >
                    {t('exploreAll')}
                  </Link>
                  <ChevronIcon className='rtl:-rotate-180' />
                </Button>
              </div>
            )}
          </div>

          <div className='grid w-full grid-cols-2 gap-4 md:grid-cols-3'>
            {items.slice(0, 3).map((zone) => {
              return (
                <ZoneCard
                  key={zone.id}
                  href={`/${locale}/zones/${zone.slug}`}
                  buttonText={zone.button?.label ?? 'Explore'}
                  media={zone.featuredBanner}
                  presentedBy={
                    zone.sponsorLogo
                      ? {
                          name: `Presented by ${zone.sponsorLogo.title}`,
                          logoUrl: zone.sponsorLogo.url,
                        }
                      : undefined
                  }
                  zoneLogoUrl={zone.zoneLogo?.url}
                  isNew={zone.newZone ?? false}
                />
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
